module.exports = __webpack_public_path__ + "static/media/dw2.7c247abf.png";